exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* below are styles for modal controls whre bfp is not the root parent */\r\n.bfp-btn {\r\n    margin: 0px 7px 0px 6px;\r\n}\r\n\r\n.bfp-btn .btn_save,\r\n.bfp-btn .btn_next,\r\n.bfp-btn .btn_prev,\r\n.bfp-btn .btn_cancel {\r\n    width: 84px;\r\n}\r\n\r\n.sn_field .bfp-field .label {\r\n    width: 40%;\r\n}\r\n\r\n.sn_field .bfp-field .value {\r\n    width: 60%;\r\n}\r\n\r\n.sn-img-btn {\r\n    display: inline-block;\r\n    padding-right: 10px;\r\n}\r\n\r\n.sn-img-btn .sn-ib-green:hover {\r\n    opacity: 0.8;\r\n    cursor: pointer;\r\n}\r\n\r\n.sn-img-btn .sn-ib-green {\r\n    color:#3dc115;\r\n    font-size: 1.3em;\r\n}\r\n\r\n.sn-img-btn i span {\t\r\n\tdisplay:none;\r\n\tcolor:#fff;\r\n\tbackground:#054795;\r\n\tpadding:8px;\r\n\tborder-radius:4px;\r\n\t-moz-border-radius:4px;\r\n\t-webkit-border-radius:4px;\r\n\ttext-align:center;\r\n    position: absolute;\r\n\tz-index:10;\r\n    white-space:nowrap;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/beasley/beasley.component.css
// module id = ../../../../../src/app/components/beasley/beasley.component.css
// module chunks = main